import React from 'react';
import Hero from './Hero';

const Home = ({ openbar }) => {
	return (
		<div id='home' className='bg-hero-pattern bg-no-repeat bg-cover bg-center'>
			<Hero openbar={openbar} />
		</div>
	);
};

export default Home;
